import Vue from 'vue'
import Router from 'vue-router'
import homeRoute from './homeRoute'
import user from './user'
import profile from './profile'
Vue.use(Router)
export const constantRouterMap = [
  {path: '/login', component: resolve => require(['@/views/login'], resolve), hidden: true},
  { path: '/404', component: resolve => require(['@/views/404'], resolve), hidden: true },
  { path: '/test', component: resolve => require(['@/views/test'], resolve), hidden: true },
  homeRoute,
  user,
  profile
]
export const asyncRouterMap = [
  { path: '*', redirect: '/404', hidden: true }
]
export default new Router({
  routes: constantRouterMap

})



// WEBPACK FOOTER //
// ./src/router/index.js